import { toTwoDigits, MILLISECONDS } from '../../common/utils/date';
export const formatDate = (locale, ms) => new Date(ms).toLocaleString(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
});
export const formatTime = (ms) => {
    let hours = '00';
    let minutes = '00';
    let seconds = '00';
    if (ms > 0) {
        hours = Math.floor(ms / MILLISECONDS.ONE_HOUR);
        minutes = Math.floor((ms % MILLISECONDS.ONE_HOUR) / MILLISECONDS.ONE_MINUTE);
        seconds = Math.floor((ms % MILLISECONDS.ONE_MINUTE) / MILLISECONDS.ONE_SECOND);
    }
    return `${toTwoDigits(hours)} : ${toTwoDigits(minutes)} : ${toTwoDigits(seconds)}`; // add localized duration
};
//# sourceMappingURL=format.js.map